require('./brokerOrdersAndMovementsMovementsTab.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const InformativeItem = require('components/commons/informativeItem/informativeItem');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const { LabelDate } = require('commonsComponents/labelDate');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const BrokerOrdersAndMovementsMovementsFilter = require('components/broker/brokerOrdersAndMovementsMovementsFilter/brokerOrdersAndMovementsMovementsFilter');
const BrokerOrdersAndMovementsMovementsHeader = require('components/broker/brokerOrdersAndMovementsMovementsHeader/brokerOrdersAndMovementsMovementsHeader');
// @helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { conditionalValueOrHyphen } = require('utilities/valueHelper');
// @constants
const { DATE_FORMAT_ES, HYPHEN, BROKER_TYPE_STOCKS_NEW_DECIMALS } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { TYPE_CRYPTO_PG } = require('../../../constants');

class BrokerOrdersAndMovementsMovementsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedValue: null,
            filterSettingsOpen: false
        };

        this.handleValueChange = this.handleValueChange.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    componentDidMount() {
        this.getContractValues();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { immContract, getContractValues } = this.props;

        if (nextProps.immContract.get('walletNumber') !== immContract.get('walletNumber')) {
            getContractValues(nextProps.immContract);
            this.setState({
                selectedValue: null
            });
        }
    }

    getContractValues() {
        const { immContract } = this.props;

        if (immContract.get('type') === TYPE_CRYPTO_PG) {
            this.props.getCryptoContractValues(immContract);
        } else {
            this.props.getContractValues(immContract);
        }
    }

    getMovements() {
        const { getValueMovements, immContract, immValues } = this.props;
        const immValue = immValues.getIn([
            immContract.get('walletNumber'),
            'byId',
            this.state.selectedValue.value
        ]);

        getValueMovements(immContract, immValue);
    }

    setFilter(filters, contractId) {
        const { setFilter, immContract, immValues } = this.props;

        setFilter(filters, contractId);
        if (immContract.get('type') === TYPE_CRYPTO_PG) {
            const immValue = immValues.getIn([
                immContract.get('walletNumber'),
                'byId',
                this.state.selectedValue.value
            ]);
            this.props.applyCryptoFilter(immContract, immValue);
        } else {
            this.getMovements();
        }
    }

    buildDetailSection() {
        const { immValues, immContract } = this.props;

        const valueId = this.state.selectedValue.value;
        const isCrypto = immContract.get('type') === TYPE_CRYPTO_PG;
        const immValue = immValues.getIn([immContract.get('walletNumber'), 'byId', valueId]);
        const price = formatAmountObject(immValue.get('price'));
        const value = immValue.get('value');
        const priceText = `${formatAmount(immValue.getIn(['price', 'amount']), undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)}
             ${price.currencySymbol}`;
        const priceDate = conditionalValueOrHyphen(immValue.get('date'), DateHelper.buildFormattedDate(immValue.get('date'), DATE_FORMAT_ES));
        const titles = immValue.get('titles');
        const titlesLabel = formatText(
            `broker-ordersAndMovementsMovementsTabTitle${titles ? 's' : ''}`
        );
        const walletText = `${titles} ${titlesLabel}`;
        const valuationText = `${formatAmountObject(value)
            .amount} ${formatAmountObject(value).currencySymbol}`;
        const currencyText = immValue.getIn(['price', 'currency']);

        return (
            <section className="broker-orders-and-movements-movements-tab__details">
                <div className="row">
                    <div className="col-xs-3">
                        <InformativeItem
                            isUppercaseTitle={true}
                            title={formatText('broker-ordersAndMovementsMovementsTabPrice')}
                            primaryText={priceText}
                            secondaryText={priceDate}
                        />
                    </div>
                    <div className="col-xs-2">
                        <InformativeItem
                            isUppercaseTitle={true}
                            title={formatText('broker-ordersAndMovementsMovementsTabInWallet')}
                            primaryText={walletText}
                        />
                    </div>
                    <div className="col-xs-2">
                        <InformativeItem
                            isUppercaseTitle={true}
                            title={formatText('broker-ordersAndMovementsMovementsTabValuation')}
                            primaryText={valuationText}
                        />
                    </div>
                    <div className="col-xs-1">
                        <InformativeItem
                            isUppercaseTitle={true}
                            title={formatText('broker-ordersAndMovementsMovementsTabCurrency')}
                            primaryText={currencyText}
                        />
                    </div>
                </div>
            </section>
        );
    }

    buildEmptyState(messageKey) {
        return (
            <div className="broker-orders-and-movements-activity__empty-state">
                <EmptyState primaryText={formatText(messageKey)} iconType="noitems-wealth" />
            </div>
        );
    }

    buildError() {
        const errorMessage = formatText('broker-contractActivityError');

        const retryButton = (
            <OKButton
                id="btn_brokerOrdersAndMovementsActivity_errorMessage_retry"
                onClick={this.handleRetry}
            >
                <FormattedText value="broker-ordersAndMovementsRetry" />
            </OKButton>
        );

        return (
            <div className="broker-orders-and-movements-activity__empty-state">
                <EmptyState primaryText={errorMessage} button={retryButton} iconType="nointernet-wealth"/>
            </div>
        );
    }

    movementsByDateInDescendingOrder(){
        const { immValueMovements } = this.props;
        const valueId = this.state.selectedValue.value;
        const immMovementsById = immValueMovements.getIn([valueId, 'byId']);
        const immMovementsByOrder = immValueMovements.getIn([valueId, 'byOrder']);

        const immMovementsInOrderByDate = immMovementsByOrder.sort((previousMovementId, nextMovementId) => {
            const previousMovement = immMovementsById.get(previousMovementId);
            const nextMovement = immMovementsById.get(nextMovementId);

            return previousMovement.get('date') < nextMovement.get('date') ? 1 : -1;
        });

        return immMovementsInOrderByDate;
    }

    buildTableContent(movementsToShow, immMovementList, language) {
        const rowsContent = movementsToShow.map((movementId, index) => {
            const immMovement = immMovementList.get(movementId);
            if (!immMovement) {
                return null;
            }

            const labelDateComponent = immMovement.get('date') ? (<LabelDate
                date={immMovement.get('date')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />)
                : HYPHEN;
            const plainAmountObject = getPlainAmountObject(immMovement.get('price'));
            const price = immMovement.getIn(['price', 'amount']) ? (
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            ) : HYPHEN;
            const description = immMovement.get('description');

            return (
                <OKTableRow key={index}>
                    <OKTableCell className="broker-orders-and-movements-movements-tab__table-date">
                        {labelDateComponent}
                    </OKTableCell>
                    <OKTableCell className="broker-orders-and-movements-movements-tab__table-movement-type">
                        {this.movementType(description)}
                    </OKTableCell>
                    <OKTableCell className="broker-orders-and-movements-movements-tab__table-titles">
                        {immMovement.get('titles')}
                    </OKTableCell>
                    <OKTableCell className="broker-orders-and-movements-movements-tab__table-valuation">
                        {price}
                    </OKTableCell>
                </OKTableRow>
            );
        }).filter(row => row !== null);

        return (
            <OKTable>
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell
                            asHeader={true}
                            className="broker-orders-and-movements-movements-tab__table-date"
                        >
                            <FormattedText value="broker-ordersAndMovementsMovementsTabExecutionDate" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="broker-orders-and-movements-movements-tab__table-movement-type"
                        >
                            <FormattedText value="broker-ordersAndMovementsMovementsTabMovementType" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="broker-orders-and-movements-movements-tab__table-titles"
                        >
                            <FormattedText value="broker-ordersAndMovementsMovementsTabTitles" />
                        </OKTableCell>
                        <OKTableCell
                            asHeader={true}
                            className="broker-orders-and-movements-movements-tab__table-valuation"
                        >
                            <FormattedText value="broker-ordersAndMovementsMovementsTabPrice" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {rowsContent}
                </tbody>
            </OKTable>
        );
    }

    buildTable() {
        const { immValueMovements, immContract, immValues } = this.props;
        const valueId = this.state.selectedValue.value;
        const notReady =
            !immValueMovements.get(valueId) || immValueMovements.getIn([valueId, 'isFetching']);
        const hasError =
            immValueMovements.get(valueId) && !!immValueMovements.getIn([valueId, 'error']);
        const isEmpty =
            immValueMovements.get(valueId) && immValueMovements.getIn([valueId, 'byId']).size === 0;
        let content;

        if (notReady) {
            content = <LoadingSection />;
        } else if (hasError) {
            content = this.buildError();
        } else if (isEmpty) {
            content = this.buildEmptyState('broker-contractActivityEmpty');
        } else {
            const immMovements = __CONTACT_CENTER__ ? this.movementsByDateInDescendingOrder() : immValueMovements.getIn([valueId, 'byOrder']) || [];
            const language = getLanguage();
            const isCrypto = immContract.get('type') === TYPE_CRYPTO_PG;

            const immFilteredIds = immValues.getIn([
                immContract.get('walletNumber'),
                'cryptoFilteredIds',
            ]);

            if (isCrypto) {
                if (!immFilteredIds || immFilteredIds.isEmpty()) {
                    content = this.buildEmptyState('broker-contractActivityEmpty');
                } else {
                    const immMovementList = immValueMovements.getIn([valueId, 'byId']);
                    const movementsToShow = immMovements.filter(movementId => {
                        const immMovement = immMovementList.get(movementId);
                        return immMovement && immFilteredIds?.toJS()?.includes(immMovement.get('id'));
                    });

                    if (!movementsToShow || movementsToShow.size === 0) {
                        content = this.buildEmptyState('broker-contractActivityEmpty');
                    } else {
                        content = this.buildTableContent(movementsToShow, immValueMovements.getIn([valueId, 'byId']), language);
                    }
                }
            } else {
                const immMovementList = immValueMovements.getIn([valueId, 'byId']);
                content = this.buildTableContent(immMovements, immMovementList, language);
            }
        }
        return content;
    }

    buildValueOptions(immValuesById) {
        let options = [];

        immValuesById.forEach(immValue =>
            options.push({
                label: immValue.get('description'),
                value: immValue.get('id')
            })
        );

        return options;
    }

    clearFilter() {
        const { clearFilter, immContract, clearCryptoFilters } = this.props;
        const isCrypto = immContract.get('type') === TYPE_CRYPTO_PG;
        if (isCrypto) {
            const walletNumber = immContract.get('walletNumber')
            clearCryptoFilters(walletNumber);
        }
        clearFilter(this.state.selectedValue.value);
        this.getMovements();
    }

    handleRetry() {
        const hasFailedToRetrieveMovements = this.state.selectedValue != null;

        if (hasFailedToRetrieveMovements) {
            this.getMovements();
        } else {
            this.getContractValues();
        }
    }

    handleToggleFilters() {
        const newFilterStatus = !this.state.filterSettingsOpen;

        this.setState({
            filterSettingsOpen: newFilterStatus
        });
    }

    handleValueChange(selectedValue) {
        this.setState(
            {
                selectedValue
            },
            () => this.getMovements()
        );
    }

    //Bypass para immMovement.get('description'), la descripcion viene desde api.
    //se opto por esta solucion para no afectar otros servicios
    movementType(description) {
        let movementTypeDescription = {};
        movementTypeDescription['COMPRA TITULOS'] = [formatText('broker-ordersAndMovementsMovementsCompraBypass')];
        movementTypeDescription['BUY'] = [formatText('broker-ordersAndMovementsMovementsCompraBypass')];
        movementTypeDescription['VENTA DE TITULOS'] = [formatText('broker-ordersAndMovementsMovementsVentaBypass')];
        movementTypeDescription['SELL'] = [formatText('broker-ordersAndMovementsMovementsVentaBypass')];
        movementTypeDescription['SEL'] = [formatText('broker-ordersAndMovementsMovementsVentaBypass')];

        const trimDescription = description ? (description + '').trim() : '';
        const result = movementTypeDescription[trimDescription];

        if (!result) {
            return trimDescription;
        }

        return result;
    }

    getNextMovements() {
        const { immContract, immValues, getNextMovementPage } = this.props;
        const immValue = immValues.getIn([
            immContract.get('walletNumber'),
            'byId',
            this.state.selectedValue.value
        ]);
        getNextMovementPage(immValue, immContract)
    }

    render() {
        const { immValues, immContract, immValueMovements} = this.props;

        const selectLabel = formatText('broker-ordersAndMovementsMovementsTabValueToConsultLabel');
        const contractId = immContract.get('walletNumber');
        const portfolioId = immContract.get('portfolioId');
        const isLoading = !immValues.get(contractId) || immValues.getIn([contractId, 'isFetching']);
        const hasError = immValues.get(contractId) && !!immValues.getIn([contractId, 'error'])  || immValues.getIn([portfolioId, 'error']);
        const isEmpty = immValues.getIn([contractId, 'byId'])?.isEmpty();

        let content;

        if (isLoading) {
            content = <LoadingSection />;
        } else if (hasError) {
            content = this.buildError();
        } else if (isEmpty) {
            content = (
                <div className="row">
                    <div className="col-xs-offset-3 col-xs-6">
                        {this.buildEmptyState('broker-contractMovementsEmpty')}
                    </div>
                </div>
            );
        } else {
            const valueOptions = this.buildValueOptions(immValues.getIn([contractId, 'byId']));

            let selectedValueSections, footerButtonNext;

            if (!!this.state.selectedValue) {
                const valueId = this.state.selectedValue.value;
                const immFilter =
                    immValueMovements.get(valueId) && immValueMovements.getIn([valueId, 'filters']);
                const detailsSection = this.buildDetailSection();
                const tableHeader = (
                    <BrokerOrdersAndMovementsMovementsHeader
                        immFilter={immFilter}
                        onFilterClick={this.handleToggleFilters}
                        clearFilter={this.clearFilter}
                        hasError={hasError}
                    />
                );
                const tableContent = this.buildTable();
                const modalFilterMovements = immFilter ? (
                    <BrokerOrdersAndMovementsMovementsFilter
                        valueId={valueId}
                        setFilter={this.setFilter}
                        immFilter={immFilter}
                        onCloseClick={this.handleToggleFilters}
                        isModalOpen={this.state.filterSettingsOpen}
                    />
                ) : null;

                selectedValueSections = (
                    <section>
                        {detailsSection}
                        {tableHeader}
                        {tableContent}
                        {modalFilterMovements}
                    </section>
                );

                footerButtonNext = immValueMovements.getIn([ valueId, 'nextLink']) && (
                    <section className="broker-orders-and-movements-movements-tab__footer-button">
                        <OKButton
                            modifier="link-complementary"
                            onClick={() => this.getNextMovements()}
                        >
                            <FormattedText value="broker-ordersAndMovementsMovementsMoreMovements" />
                        </OKButton>
                    </section>
                );
            }
            content = (
                <div className="broker-orders-and-movements-movements-tab">
                    <section>
                        <div className="broker-orders-and-movements-movements-tab__dropdown">
                            <OKSelect
                                label={selectLabel}
                                id="selBrokerMovements"
                                name="movements-selector"
                                options={valueOptions}
                                value={this.state.selectedValue}
                                clearable={false}
                                searchable={false}
                                onChange={this.handleValueChange}
                            />
                        </div>
                    </section>
                    {selectedValueSections}
                    {footerButtonNext}
                </div>
            );
        }

        return content;
    }
}

BrokerOrdersAndMovementsMovementsTab.propTypes = {
    immValues: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    immValueMovements: PropTypes.object.isRequired,
    getContractValues: PropTypes.func.isRequired,
    getAllCryptoContractValues: PropTypes.func.isRequired,
    getValueMovements: PropTypes.func.isRequired,
    applyCryptoFilter: PropTypes.func.isRequired,
    clearCryptoFilters: PropTypes.func.isRequired,
    getNextMovementPage: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired
};

module.exports = BrokerOrdersAndMovementsMovementsTab;
